const Keycloak = require('keycloak-js');
const axios = require('axios');

function BespinSso(portalUrl) {
    console.log(portalUrl);
    this.portalUrl = portalUrl;
    var that = this;

    this.init = function() {
        return new Promise(function (resolve, reject) {
            try {
                axios.get(that.portalUrl + '/api_v2.0/general/keycloak/json', {
                    params: {
                        domain: window.location.hostname,
                        svcType: 'frontend'
                    }
                }).then(function(response) {
                    var keycloakJson = response.data.result.keycloakJson;

                    that.keycloak = new Keycloak(JSON.parse(keycloakJson));

                    that.keycloak.init({
                        onLoad: 'check-sso',
                        checkLoginIframe: true
                    });

                    resolve(that.keycloak);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    this.getKeycloak = function() {
        return this.keycloak;
    };

    this.getSessionCount = function() {
        return new Promise(function (resolve, reject) {
            try {
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                axios.get(authServerUrl + '/realms/' + realm + '/api/users/me/session-count', {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId
                    }
                }).then(function (response) {
                    resolve(response.data.count);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    this.logoutAllSession = function(withoutCurrent) {
        return new Promise(function (resolve, reject) {
            try {
                var authServerUrl = that.keycloak.authServerUrl;
                var realm = that.keycloak.realm;
                var clientId = that.keycloak.clientId;
                var token = that.keycloak.token;

                axios.get(authServerUrl + '/realms/' + realm + '/api/users/me/logout-allsession', {
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        clientId: clientId,
                        withoutCurrent: withoutCurrent
                    }
                }).then(function () {
                    resolve();
                });
            } catch (e) {
                reject(e);
            }
        });
    };

}

module.exports = BespinSso;



//////////////////
// WEBPACK FOOTER
// ./src/app/components/sso/bespinsso.js
// module id = ./src/app/components/sso/bespinsso.js
// module chunks = main